import OnboardingModal from '../components/OnboardingModal';
import baseConfig from './base';

const config = {
  ...baseConfig,
  component: OnboardingModal,
};

export default config;
